import type { AuditEntryResponse } from '@/domain/models/development.js';

export function formatReasonLine(entry: Pick<AuditEntryResponse, 'reasonLabel' | 'notes'>, reasonPrefix: string): string | null {
    const parts: string[] = [];
    if (entry.reasonLabel) {
        parts.push(`${reasonPrefix}: ${entry.reasonLabel}`);
    }
    if (entry.notes) {
        parts.push(entry.notes);
    }
    return parts.length > 0 ? parts.join(' — ') : null;
}
